import { LinkedZone } from "./types";
import { HttpClient } from "../types/httpClient";
import { linkResources } from "../utils/linkResources";

function linkZone(httpClient: HttpClient) {
  return (zone: LinkedZone): Promise<LinkedZone> =>
    linkResources(httpClient, zone);
}

export { linkZone };
